import { EXCLUDED_KEYS } from "../Pages/insights/applicationAllDetails.constant";

// Add the columns that are not to show initially but user can select them from the menu.
export const columnsNotToShowInitially = [
    "userEmail",
    "paymentOn",
    "flagPaymentFailed",
    "paymentMethod",
    "paymentMethodLabel",
    "phoneNo",
    "age",
    "email",
    "leadZipCode",
    "monthlyIncome",
    "addressCity",
    "addressState",
    "addressZipCode",
    "flagExtraWithDuration",
    "lastLnidCallOn",
    "threePsStartedOn",
    "threePsCompletedOn",
    "rasDeclineReason",
    "rasDeclineQuestion",
    "PaymentEffectiveDate"
];

// Fixed columns that will be always visible in the table.
export const fixedColumns = ["tenantTitle", "agentName", "applicantName"];

// Field not visible in UI.
export const columnNameToExcludeInUI = ["addEsc"];

// Field removed from the details page.
export const fieldsToExcludeFromDetails = ["associatedEscalations","isLocked","isManuallyUnlocked","unlockedBy","unlockedOn", ...EXCLUDED_KEYS]